module.exports = __webpack_public_path__ + "img/Colores.f6f337e3.png";